import { Routes } from '@angular/router';
import { ProjectName } from 'projects/shared/src/lib/core/enums/project-name.enum';
import { CanDeactivateGuard } from 'projects/shared/src/lib/core/guards/can-deactivate.guard';
import { CanActivateUser } from 'projects/shared/src/lib/core/guards/url-allowed.guard';
import { RouterCommonPagesEnum } from 'projects/shared/src/lib/infrastructure/enums/common-pages.enum';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    loadComponent: () => import('./pages/test/test.component').then((m) => m.TestComponent),
    canActivate: [CanActivateUser],
    data: {
      // data for canActivateAdmin
      project: ProjectName.ATR,
    },
  },
  {
    path: `${RouterCommonPagesEnum.ExampleSum}/:id`,
    pathMatch: 'full',
    loadComponent: () =>
      import('./pages/example-norm-test/example-norm-test.component').then((m) => m.ExampleNormTestComponent),
    canDeactivate: [CanDeactivateGuard],
  },
];
